import { getCookie, setCookie } from 'lib/cookies';
import { COOKIE_NAMES } from 'config';

export const refreshAccessToken = async (authApi, brand, env, refreshToken) => {
  try {
    const response = await authApi.post(`/refresh`, {
      'grant_type': 'refresh_token',
      'session_short': true,
      'token': refreshToken
    });

    const customerAuth = response.data.result;

    const CTCookie = getCookie(brand, env, COOKIE_NAMES.CUSTOMER_TOKEN);
    const cookieData = JSON.parse(CTCookie);
    const customerData = cookieData?.customer || cookieData;
    const { id, firstNames, surname, email } = customerData;
    customerData.accessToken = customerAuth;
    customerData.accessToken.customer = { id, firstNames, surname, email };
    
    setCookie(brand, env, COOKIE_NAMES.CUSTOMER_TOKEN, customerData);

    return customerAuth.accessToken;
  } catch (err) {
    console.log(err);
  }
};
